module.exports = __webpack_public_path__ + "static/media/svoboda.d9644fc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/svoboda.jpg
// module id = 557
// module chunks = 0